module.exports = __webpack_public_path__ + "img/human.109f0234.png";